<template>
	<div class="cco-favoriteLineItem">
		<a :href="lineItem.url">
			<img
				class="cco-favoriteLineItem__image"
				:class="{
					'cco-favoriteLineItem__image--whitespace': lineItem.image.whitespace,
				}"
				:src="lineItem.image.src"
				:alt="lineItem.image.title"
			/>
		</a>
		<div class="cco-favoriteLineItem__details">
			<div class="info">
				<div class="info__row">
					<p class="title">{{ lineItem.title }}</p>
					<Favorite :id="lineItem.id"></Favorite>
				</div>
				<div class="info__secondary">
					<span>{{ lineItem.brand.title }}</span>
				</div>
			</div>
			<div class="pricing">
				<div class="pricing__actions">
					<CartAddPurchasable
						:id="lineItem.purchasableId"
						:stock="lineItem.stock"
					></CartAddPurchasable>
				</div>
				<PriceObject :price="lineItem.price" />
			</div>
		</div>
	</div>
</template>

<script>
import PriceObject from "@/vue/components/objects/PriceObject.vue";
import Favorite from "@/vue/components/commerce/Favorite.vue";
import CartAddPurchasable from "@/vue/components/objects/CartAddPurchasable.vue";

export default {
	name: "CartLineItem",
	components: { PriceObject, Favorite, CartAddPurchasable },
	props: {
		lineItem: {
			type: [Object, Boolean],
			default: false,
		},
	},
	data: () => {
		return {};
	},
	methods: {},
	created() {},
};
</script>

<style lang="scss">
@import "@backend/scss/abstracts/variables.scss";
@import "@backend/scss/abstracts/mixins.scss";

.cco-favoriteLineItem {
	border-bottom: $e-border;
	padding-top: 16px;
	padding-bottom: 16px;
	display: flex;
	gap: 8px;

	&__image {
		@include size-fix(80px, 80px);

		&--whitespace {
			padding: 10px;
		}
	}
	&__details {
		width: 100%;
		display: flex;
		flex-direction: column;

		.info {
			display: flex;
			flex-direction: column;
			flex: 1;
			gap: 4px;

			&__row {
				display: flex;
				justify-content: space-between;
				align-items: flex-start;
				gap: 12px;
				max-height: 24px;

				.title {
					@include text-overflow(1);
					max-height: 22px;
					overflow: hidden;
					font-weight: $f-semibold;
				}

				.c-favorite {
					top: -8px;
					position: relative;
				}
			}

			&__secondary {
				min-height: 24px;
				line-height: 17px;
			}
		}
	}
	.pricing {
		display: flex;
		align-items: flex-end;
		justify-content: space-between;
		margin-top: 8px;

		&__actions {
			display: flex;
			align-items: center;
			gap: 8px;

			.c-cartAddPurchasable {
				.o-loader {
					span {
						background-color: $c-blue;
					}
				}
				.o-btn {
					@include size-fix(130px, 35px);
					white-space: nowrap;

					font-size: $font-disclaimer-size;
					line-height: $font-disclaimer-size;
				}
				&:hover {
					.o-loader {
						span {
							background-color: $c-white;
						}
					}
				}
			}
		}
	}
}

@media all and (max-width: 450px) {
	.cco-favoriteLineItem {
		&__image {
			@include size-fix(60px, 60px);

			&--whitespace {
				padding: 0;
			}
		}
	}
}

@media all and (max-width: 425px) {
	.cco-favoriteLineItem {
		&__details {
			.pricing {
				flex-direction: column-reverse;
				gap: 4px;
				align-items: flex-start;
			}
		}
	}
}
</style>
